namespace GeniuzPOS.ReportMasterData {
    export class Report_1602Columns {
        static columnsKey = 'ReportMasterData.Report_1602';
    }
}
